import { LogLevel } from "@shopliftr/common-ng";
import { environment as baseConfig } from "./environment.base";
import { IAppConfig } from "../app/common/interfaces/app-config";

export const environment: IAppConfig = {
    ...baseConfig,
    production: true,
    staging: false,
    googleMapsApiKey: "AIzaSyBdte_nNIvL657MasaOnzTkH8zfgxPO--o",
    apiUrl: "https://internal-api.mygrocerydeals.com",
    batchUrl: "http://batch.mygrocerydeals.com",
    product: {
        assetsUrl: "s3.amazonaws.com/mgd.web.products",
        cloudfrontUrl: "products.mygrocerydeals.com",
        elasticSearchDelay: 1500
    },
    smart: {
        assetsUrl: "https://assets.staging.ads.mygrocerydeals.com"
    },
    rollbar: {
        level: LogLevel.Error,
        environment: "production",
        accessToken: "05b836cbd4ff43748bb83b653af71ba1"
    },
    newrelic: {
        enabled: true,
        trackRouteChanges: true,
        logLevel: LogLevel.Warning,
        includeUserNames: false
    },
    authentication: {
        ...baseConfig.authentication,
        logins: []
    },
    displayUncaughtErrorMessage: false
};
